import React from 'react';
import marked from 'marked';
import styles from './Changelog.css';
import { Fetch } from '../common/Fetch';
import { assetUrl } from 'utils/appUrl';
export const Changelog = () => {
    return (React.createElement(Fetch, { cacheKey: "releaseInfo", href: assetUrl('changelog.md') }, data => (React.createElement(React.Fragment, null, typeof data === 'string' &&
        renderMarkdown(data)))));
};
const renderMarkdown = (str) => {
    const html = marked(str, { gfm: true });
    return React.createElement("div", { className: styles['markdown-body'], dangerouslySetInnerHTML: { __html: html } });
};
